export enum RebalancingStep {
  SELECT,
  INPUT_PAY,
  INPUT_WEIGHTS,
  INPUT_OK,
  CALCULATE,
  REFETCH_QUOTES,
  APPROVAL_REQUIRED,
  APPROVAL_OK,
  EXPIRED,
  IN_PROGRESS,
  PARTLY_FINISHED,
  FINISHED,
}
